'use strict';

require('./dist/featureFlags.js');
module.exports = 'feature-flags';
